import { CommonModule } from '@angular/common'
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core'
import { MatCardModule } from '@angular/material/card'
import { SharedUtilsDirectivesModule } from 'libs/shared/utils/directives/src'
import { GbMascotSuccessComponent } from './gb-mascot-success/gb-mascot-success.component'

import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { MatButtonModule } from '@angular/material/button'
import { MatChipsModule } from '@angular/material/chips'
import { MatDialogModule } from '@angular/material/dialog'
import { MatDividerModule } from '@angular/material/divider'
import { MatIconModule } from '@angular/material/icon'
import { MatInputModule } from '@angular/material/input'
import { MatMenuModule } from '@angular/material/menu'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { TranslateModule } from '@ngx-translate/core'
import { GbSafePipe } from 'libs/shared/utils/pipes/src/lib/gb-safe-pipe/gb-safe.pipe'
import { GbSearchPipe } from 'libs/shared/utils/pipes/src/lib/gb-search-pipe/gb-search.pipe'
import { GbAlertBoxComponent } from './gb-alert-box/gb-alert-box.component'
import { GbAmexIconComponent } from './gb-amex-icon/gb-amex-icon.component'
import { GbApplePayIconComponent } from './gb-apple-pay-icon/gb-apple-pay-icon.component'
import { GbCalloutComponent } from './gb-callout/gb-callout.component'
import { GbCardIconComponent } from './gb-card-icon/gb-card-icon.component'
import { GbCheckInInstructionsComponent } from './gb-check-in-instructions/gb-check-in-instructions.component'
import { GbDashedCircleIconComponent } from './gb-dashed-circle-icon/gb-dashed-circle-icon.component'
import { GbFilterChipsComponent } from './gb-filter-chips/gb-filter-chips.component'
import { GbFlagIconComponent } from './gb-flag-icon/gb-flag-icon.component'
import { GbGooglePayIconComponent } from './gb-google-pay-icon/gb-google-pay-icon.component'
import { GbIntlPhoneInputComponent } from './gb-intl-phone-input/gb-intl-phone-input.component'
import { GbItemSearchComponent } from './gb-item-search/gb-item-search.component'
import { GbItemsObserverComponent } from './gb-items-observer/gb-items-observer.component'
import { GbLoadingProgressComponent } from './gb-loading-progress/gb-loading-progress.component'
import { GbLoadingSpinnerComponent } from './gb-loading-spinner/gb-loading-spinner.component'
import { GbMascotComponent } from './gb-mascot/gb-mascot.component'
import { GbMastercardIconComponent } from './gb-mastercard-icon/gb-mastercard-icon.component'
import { GbPasswordHintComponent } from './gb-password-hint/gb-password-hint.component'
import { GbPendingUpdateComponent } from './gb-pending-update/gb-pending-update.component'
import { GbQuillTextComponent } from './gb-quill-text/gb-quill-text.component'
import { GbRangeSliderComponent } from './gb-range-slider/gb-range-slider.component'
import { GbSkeletonLoaderComponent } from './gb-skeleton-loader/gb-skeleton-loader.component'
import { GbTipIconComponent } from './gb-tip-icon/gb-tip-icon.component'
import { GbVisaIconComponent } from './gb-visa-icon/gb-visa-icon.component'

@NgModule({
  imports: [
    CommonModule,
    SharedUtilsDirectivesModule,
    TranslateModule,
    MatCardModule,
    MatIconModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    FormsModule,
    MatInputModule,
    MatMenuModule,
    MatButtonModule,
    MatDividerModule,
    ReactiveFormsModule,
    MatChipsModule,
    GbSearchPipe,
    GbSafePipe,
  ],
  declarations: [
    GbMascotSuccessComponent,
    GbCalloutComponent,
    GbLoadingSpinnerComponent,
    GbIntlPhoneInputComponent,
    GbItemSearchComponent,
    GbItemsObserverComponent,
    GbAlertBoxComponent,
    GbMascotComponent,
    GbQuillTextComponent,
    GbMastercardIconComponent,
    GbAmexIconComponent,
    GbVisaIconComponent,
    GbGooglePayIconComponent,
    GbApplePayIconComponent,
    GbRangeSliderComponent,
    GbTipIconComponent,
    GbSkeletonLoaderComponent,
    GbPasswordHintComponent,
    GbCheckInInstructionsComponent,
    GbPendingUpdateComponent,
    GbFilterChipsComponent,
    GbFlagIconComponent,
    GbLoadingProgressComponent,
    GbCardIconComponent,
    GbDashedCircleIconComponent,
  ],
  exports: [
    GbMascotSuccessComponent,
    GbCalloutComponent,
    GbLoadingSpinnerComponent,
    GbIntlPhoneInputComponent,
    GbItemsObserverComponent,
    GbAlertBoxComponent,
    GbMascotComponent,
    GbQuillTextComponent,
    GbMastercardIconComponent,
    GbAmexIconComponent,
    GbVisaIconComponent,
    GbGooglePayIconComponent,
    GbApplePayIconComponent,
    GbRangeSliderComponent,
    GbTipIconComponent,
    GbSkeletonLoaderComponent,
    GbItemSearchComponent,
    GbPasswordHintComponent,
    GbCheckInInstructionsComponent,
    GbPendingUpdateComponent,
    GbFilterChipsComponent,
    GbFlagIconComponent,
    GbCardIconComponent,
    GbDashedCircleIconComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedUiModule {}
